'use client'
import dynamic from 'next/dynamic'

import useClevertapForSrp from '@/src/hooks/analytics/clevertap/srp'
import { useThemedToast } from '@/src/hooks/ui/useThemedToast'

import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { useHomePageSearchManager } from './hooks/useHomePageSearchManager'
import useHomepageGtmEvent from '@/src/hooks/analytics/gtm/homepage'
import useClevertapForHomepage from '@/src/hooks/analytics/clevertap/homepage'
import { useEffect } from 'react'

// Dynamic imports for code splitting
const MobileSearchForm = dynamic(
    () => import(/* webpackChunkName: "mobile-search-form" */ './MobileSearchForm'),
    {
        ssr: true
    }
)

const DesktopSearchForm = dynamic(
    () => import(/* webpackChunkName: "desktop-search-form" */ './DesktopSearchForm'),
    {
        ssr: true
    }
)

interface SearchFormProps {
    isMobile: boolean
    serverRecentSearches: RecentSearchListItem[]
    hideMulticity?: boolean
}

const SearchForm: React.FC<SearchFormProps> = ({ isMobile, serverRecentSearches, hideMulticity }) => {
    // Common business logic
    // Mobile: max 3 segments, Desktop: max 6 segments
    const searchManager = useHomePageSearchManager({ maxSegments: isMobile ? 3 : 6, serverRecentSearches })
    const { showError } = useThemedToast()
    const { triggerSrpEvent } = useClevertapForSrp()
    const { pushPageViewEvent } = useHomepageGtmEvent()
    const { triggerHomepageLoadEvent } = useClevertapForHomepage()
    useEffect(() => {
        pushPageViewEvent()
        triggerHomepageLoadEvent('Air_PageLoad')
    }, [])

    // Conditional rendering based on server-side detection
    if (isMobile) {
        return (
            <MobileSearchForm 
                searchManager={searchManager} 
                showError={showError} 
                triggerSrpEvent={triggerSrpEvent}
                hideMulticity={hideMulticity}
            />
        )
    }

    return (
        <DesktopSearchForm 
            searchManager={searchManager} 
            showError={showError} 
            triggerSrpEvent={triggerSrpEvent}
            hideMulticity={hideMulticity}
        />
    )
}

export default SearchForm
